import {FC, SVGProps} from 'react';

export const AlfaBankBadgeIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden {...props}>
		<rect width="16" height="16" rx="8" fill="black" />
		<path
			d="M5.5 10.7244H10.4294V11.75H5.5V10.7244ZM6.96625 8.30375H8.91063L9.23875 9.335H10.3169L8.86188 5C8.72125 4.58375 8.55813 4.25 8.00125 4.25C7.44438 4.25 7.27375 4.57812 7.1275 5L5.605 9.33313H6.61562L6.96625 8.30375V8.30375ZM7.9525 5.375H7.97687L8.63125 7.4375H7.2625L7.9525 5.375V5.375Z"
			fill="#F3F3F3"
		/>
	</svg>
);
